import { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import ReactJson from 'react-json-view'
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { IoClipboardOutline, IoCheckmarkDoneSharp } from 'react-icons/io5';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
};

export default function TemplateJSONView({ el }) {
  const [open, setOpen] = useState(false);
  const [icon, setIcon] = useState(false)
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const onCopy = () => {
    setIcon(true);
    setTimeout(() => {
      setIcon(false);
    }, 800);

  }

  return (
    <div>
      <Button id='jsoncode' style={{ color: "white", display: "flex", paddingTop: 0, marginTop: 0, paddingLeft: 0, marginLeft: 0 }} onClick={handleOpen}>
        <i className='fa fa-code fa-lg'></i>
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'>
        <Box sx={style}>

          <div style={{ height: '46vh', width: "50vw", overflow: "scroll", padding: "2rem", background: "#1d1f21", border: '2px solid gray' }}>

            <CopyToClipboard style={{ position: 'absolute', right: '1.6rem', top: "1.2rem", cursor: 'pointer', fontSize: "1.2rem" }} onCopy={onCopy} text={JSON.stringify(el)}>
              {icon ? <IoCheckmarkDoneSharp style={{ cursor: 'pointer' }} /> : <IoClipboardOutline style={{ cursor: 'pointer' }} />}
            </CopyToClipboard>
            <ReactJson theme={'tomorrow'} iconStyle='square' collapsed='1' src={el} />
          </div>
        </Box>
      </Modal>
    </div>
  );
}
